<style lang="scss">
.OtpSettings {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #eee;
    .title { font-size: 14px; font-weight: bold; margin-bottom: 8px; }
    .hint { font-size: 12px; color: #888; line-height: 1.6; margin: 8px 0; }
    .secret { font-family: monospace; word-break: break-all; background: #f5f5f5; padding: 8px; border-radius: 4px; font-size: 12px; }
    .qr { display: block; margin: 10px auto; width: 160px; height: 160px; }
    .row { margin-top: 10px; }
    .switch-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
    .field {
        width: 100%; box-sizing: border-box; height: 36px; line-height: 36px;
        padding: 0 10px; border: 1px solid #ddd; border-radius: 4px; margin-top: 8px;
    }
    .toggle {
        min-width: 48px; height: 28px; border-radius: 14px; border: none; padding: 0 4px;
        background: #ccc; position: relative; transition: background .2s; cursor: pointer;
        &.on { background: #4477ad; }
        &:disabled { opacity: 0.6; cursor: not-allowed; }
        span {
            display: block; width: 22px; height: 22px; border-radius: 50%; background: #fff;
            transition: transform .2s; transform: translateX(0);
        }
        &.on span { transform: translateX(20px); }
    }
    .btn-row { margin-top: 12px; display: flex; gap: 10px; }
    .btn {
        padding: 8px 16px; border-radius: 4px; border: 1px solid #ddd; background: #f5f5f5; cursor: pointer;
        &.primary { background: #4477ad; color: #fff; border-color: #4477ad; }
    }
}
</style>
<template>
    <div class="OtpSettings">
        <div class="switch-row">
            <div>
                <div class="title">谷歌验证器</div>
                <p class="hint">开启后，登录时需输入 Google Authenticator 中的 6 位验证码</p>
            </div>
            <button type="button" class="toggle" :class="{on: enabled}" :disabled="loading || binding" @click="toggleSwitch()">
                <span />
            </button>
        </div>

        <div v-if="binding" class="row">
            <p class="hint">请使用 Google Authenticator 扫描二维码，或手动输入密钥：</p>
            <img v-if="bindInfo.otpauth_uri" class="qr" :src="qrUrl" alt="OTP QR">
            <p class="secret">{{ bindInfo.secret }}</p>
            <input v-model="bindForm.code" class="field" maxlength="6" placeholder="6位验证码">
            <div class="btn-row">
                <button type="button" class="btn" @click="cancelBind()">取消</button>
                <button type="button" class="btn primary" :disabled="loading" @click="confirmBind()">确认绑定</button>
            </div>
        </div>

        <div v-if="!binding && showConfirmOff" class="row">
            <p class="hint">关闭验证需输入当前谷歌验证码</p>
            <input v-model="offForm.code" class="field" maxlength="6" placeholder="6位验证码">
            <div class="btn-row">
                <button type="button" class="btn" @click="cancelOff()">取消</button>
                <button type="button" class="btn primary" :disabled="loading" @click="submitOff()">确认关闭</button>
            </div>
        </div>

        <div v-if="!binding && showConfirmOn" class="row">
            <p class="hint">重新开启需输入当前谷歌验证码</p>
            <input v-model="onForm.code" class="field" maxlength="6" placeholder="6位验证码">
            <div class="btn-row">
                <button type="button" class="btn" @click="cancelOn()">取消</button>
                <button type="button" class="btn primary" :disabled="loading" @click="submitOn()">确认开启</button>
            </div>
        </div>

        <div v-if="bound && !binding && !showConfirmOff && !showConfirmOn && !showConfirmUnbind" class="row">
            <p class="hint">换手机或更换验证器应用时，可先解绑再重新绑定</p>
            <div class="btn-row">
                <button type="button" class="btn" :disabled="loading" @click="startUnbind()">解绑验证器</button>
            </div>
        </div>

        <div v-if="showConfirmUnbind" class="row">
            <p class="hint">{{ enabled ? '解绑需输入当前谷歌验证码' : '确认解绑后将清除验证器绑定' }}</p>
            <input v-if="enabled" v-model="unbindForm.code" class="field" maxlength="6" placeholder="6位验证码">
            <div class="btn-row">
                <button type="button" class="btn" @click="cancelUnbind()">取消</button>
                <button type="button" class="btn primary" :disabled="loading" @click="submitUnbind()">确认解绑</button>
            </div>
        </div>
    </div>
</template>

<script>
import ajax from '@lottery.2.0/library/ajax.js'

export default {
    name: 'OtpSettings',
    data() {
        return {
            loading: false,
            enabled: false,
            bound: false,
            binding: false,
            showConfirmOff: false,
            showConfirmOn: false,
            showConfirmUnbind: false,
            bindInfo: { secret: '', otpauth_uri: '' },
            bindForm: { code: '' },
            offForm: { code: '' },
            onForm: { code: '' },
            unbindForm: { code: '' },
        }
    },
    computed: {
        qrUrl() {
            if (!this.bindInfo.otpauth_uri) return ''
            return 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + encodeURIComponent(this.bindInfo.otpauth_uri)
        }
    },
    mounted() {
        this.loadStatus()
    },
    activated() {
        this.loadStatus()
    },
    methods: {
        api(method, url, data) {
            return ajax({ method, url, data })
        },
        loadStatus() {
            return this.api('GET', 'user/otp/status').then(res => {
                if (res.data && res.data.status == 1) {
                    this.enabled = !!res.data.data.otp_enabled
                    this.bound = !!res.data.data.otp_bound
                }
            }).catch(() => {})
        },
        toggleSwitch() {
            if (this.loading || this.binding) return
            this.onSwitch(!this.enabled)
        },
        onSwitch(val) {
            if (val) {
                if (this.bound) {
                    this.showConfirmOn = true
                    this.showConfirmOff = false
                    this.enabled = false
                } else {
                    this.startBind()
                }
            } else {
                if (!this.bound) {
                    return this.Err('请先绑定谷歌验证器')
                }
                this.showConfirmOff = true
                this.showConfirmOn = false
                this.enabled = true
            }
        },
        startBind() {
            this.loading = true
            this.showConfirmOff = false
            this.showConfirmOn = false
            this.showConfirmUnbind = false
            this.api('POST', 'user/otp', { action: 'bind_start' }).then(res => {
                this.loading = false
                if (res.data && res.data.status == 1) {
                    this.binding = true
                    this.bindInfo = res.data.data
                    this.bindForm = { code: '' }
                    this.enabled = false
                } else {
                    this.Err((res.data && res.data.msg) || '操作失败')
                }
            }).catch(err => {
                this.loading = false
                this.Err((err.data && err.data.msg) || '请求失败')
            })
        },
        cancelBind() {
            this.binding = false
            this.bindInfo = { secret: '', otpauth_uri: '' }
            this.enabled = false
        },
        confirmBind() {
            if (!this.bindForm.code) {
                return this.Err('请输入验证码')
            }
            this.loading = true
            this.api('POST', 'user/otp', {
                action: 'bind',
                code: this.bindForm.code,
            }).then(res => {
                this.loading = false
                if (res.data && res.data.status == 1) {
                    this.binding = false
                    this.enabled = true
                    this.bound = true
                    this.Suc('绑定成功')
                } else {
                    this.Err((res.data && res.data.msg) || '绑定失败')
                }
            }).catch(err => {
                this.loading = false
                this.Err((err.data && err.data.msg) || '绑定失败')
            })
        },
        cancelOff() {
            this.showConfirmOff = false
            this.enabled = true
            this.offForm = { code: '' }
        },
        submitOff() {
            if (!this.offForm.code) {
                return this.Err('请输入验证码')
            }
            this.loading = true
            this.api('POST', 'user/otp', {
                action: 'disable',
                code: this.offForm.code,
            }).then(res => {
                this.loading = false
                if (res.data && res.data.status == 1) {
                    this.showConfirmOff = false
                    this.enabled = false
                    this.Suc('已关闭谷歌验证')
                } else {
                    this.Err((res.data && res.data.msg) || '操作失败')
                }
            }).catch(err => {
                this.loading = false
                this.Err((err.data && err.data.msg) || '操作失败')
            })
        },
        cancelOn() {
            this.showConfirmOn = false
            this.enabled = false
            this.onForm = { code: '' }
        },
        submitOn() {
            if (!this.onForm.code) {
                return this.Err('请输入验证码')
            }
            this.loading = true
            this.api('POST', 'user/otp', {
                action: 'enable',
                code: this.onForm.code,
            }).then(res => {
                this.loading = false
                if (res.data && res.data.status == 1) {
                    this.showConfirmOn = false
                    this.enabled = true
                    this.Suc('已开启谷歌验证')
                } else {
                    this.Err((res.data && res.data.msg) || '操作失败')
                }
            }).catch(err => {
                this.loading = false
                this.Err((err.data && err.data.msg) || '操作失败')
            })
        },
        startUnbind() {
            this.showConfirmUnbind = true
            this.showConfirmOff = false
            this.showConfirmOn = false
            this.unbindForm = { code: '' }
        },
        cancelUnbind() {
            this.showConfirmUnbind = false
            this.unbindForm = { code: '' }
        },
        submitUnbind() {
            if (this.enabled && !this.unbindForm.code) {
                return this.Err('请输入验证码')
            }
            this.loading = true
            const payload = { action: 'unbind' }
            if (this.enabled) {
                payload.code = this.unbindForm.code
            }
            this.api('POST', 'user/otp', payload).then(res => {
                this.loading = false
                if (res.data && res.data.status == 1) {
                    this.showConfirmUnbind = false
                    this.enabled = false
                    this.bound = false
                    this.unbindForm = { code: '' }
                    this.Suc('已解绑谷歌验证器')
                } else {
                    this.Err((res.data && res.data.msg) || '解绑失败')
                }
            }).catch(err => {
                this.loading = false
                this.Err((err.data && err.data.msg) || '解绑失败')
            })
        },
    }
}
</script>
